import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { defineCustomElements } from "@ionic/pwa-elements/loader";

import * as Sentry from "@sentry/capacitor";
import * as SentryReact from "@sentry/react";

if (!(import.meta.env.MODE === "development")) {
  Sentry.init(
    {
      dsn: "https://10c84671878a54f0ab24c29c378ef87f@sentry.open.studio/190",
      integrations: [SentryReact.browserTracingIntegration()],
    },
    // Forward the init method from @sentry/react
    SentryReact.init
  );
}
const container = document.getElementById("root");
defineCustomElements(window);
const root = createRoot(container!);
root.render(<App />);
